import { Card, CardContent, Slide, Theme, Typography } from '@material-ui/core';
import React, { ReactElement } from 'react';
import userCardStyles from './AlmeUserResponse.styles';
import { withStyles, WithStyles, createStyles, makeStyles } from '@material-ui/core/styles';
import { getMaskedUserInput } from '../AlmeResponseUtils';
import { AlmeMarkdownResponseNext } from '../AlmeResponse';
import { FocusComponentProps } from '../../../models/ComponentProps';

const useStyles = makeStyles(({ spacing }: Theme) =>
    createStyles({
        userCardContainer: {
            display: 'flex',
            flexFlow: 'row nowrap',
            justifyContent: 'flex-end',
        },
    }),
);

export type AlmeUserResponseCardClasses = Record<"userCardContainer", string>;

interface AlmeUserResponseProps extends WithStyles<typeof userCardStyles> {
    response: AlmeMarkdownResponseNext;
    responseRevision: string;
    entryId: string;
    userResponseRef: React.RefObject<HTMLDivElement>;
    onScroll: () => void;
    userIcon?: ReactElement;
    focusProps?: FocusComponentProps;
}

const AlmeUserResponse: React.FC<AlmeUserResponseProps> = (props: AlmeUserResponseProps) => {
    const classes: AlmeUserResponseCardClasses = useStyles();
    const maskedUserInput = getMaskedUserInput(props.response);
    const hasUserInput = !!maskedUserInput;
    const responseAccessibilityLabel = <span hidden={true} aria-hidden="false">Message from user. </span>;

    if (!hasUserInput) {
        return null;
    }

    return (
        <Slide direction='up' in onEntered={props.onScroll}>
            <div className={classes.userCardContainer} id={`alme-user-card-${props.responseRevision}`}>
                <Card
                    className={props.classes.userCard}
                    key={`${props.entryId}-user`}
                    ref={props.userResponseRef}
                    {...props.focusProps}
                >
                    <CardContent className={props.classes.ivaCardContent}>
                        {responseAccessibilityLabel}
                        <Typography variant="body1" className={props.classes.userCardBody}>{maskedUserInput}</Typography>
                    </CardContent>
                </Card>
                {props.userIcon}
            </div>
        </ Slide>
    );
};

export default withStyles(userCardStyles)(AlmeUserResponse);
